import { useBaseMask } from './useBaseMask'
import { InputAttributes, PatternFormatProps } from './utils/types'
import { usePatternFormat } from './utils/usePatternFormat'

export function usePattern<BaseType = InputAttributes>(
  props: PatternFormatProps<BaseType>,
) {
  const patternFormatProps = usePatternFormat(props)
  return useBaseMask(patternFormatProps)
}
